export enum EnvVariable {
    DEBUG_MODE,
    API_URL,
    API_KEY,
}